module.exports = __webpack_public_path__ + "static/img/logo.cf036a4d.jpg";